import type { FC } from "react";
import { useMemo } from "react";

import { abbrNumberSupportNegativeFilter } from "app/filters/ngFilters";

import { getTableColumns } from "../../columns/tableColumnsBuilder";
import { customAbbrNumberSupportNegativeFilter, getDescriptionText } from "../../tests/helpers";
import type { IMarketingChannelsPresetsProps } from "../../types";
import HeatmapWidgetTable from "../HeatmapWidgetTable/HeatmapWidgetTable";

const GrowthDriversTable: FC<IMarketingChannelsPresetsProps> = ({
    subTitleFilters,
    data,
    domains,
    isLoading,
    isPoP,
    ...props
}) => {
    const columns = useMemo(
        () =>
            data.length > 0 && !isLoading
                ? // @ts-expect-error FIXME: filter signature (val, boolean, number) doesn't match expected (val: number, digits: number) => string
                  getTableColumns(domains, abbrNumberSupportNegativeFilter(), "Growth drivers", props.withOpacity)
                : [],
        [data.length, domains, isLoading],
    );

    const descriptionText = getDescriptionText(isPoP, "mmx.growth.drivers.description");

    return (
        <HeatmapWidgetTable
            data-automation="growth-drivers-table"
            title="mmx.growth.drivers.title"
            tooltip="mmx.growth.drivers.tooltip"
            data={data}
            columns={columns}
            isLoading={isLoading}
            descriptionText={descriptionText}
            subtitleFilters={subTitleFilters}
            formatter={customAbbrNumberSupportNegativeFilter()}
            {...props}
        />
    );
};

export default GrowthDriversTable;
